<template>
  <div v-if="!validate" class="delight mb-3">
    <loading :active.sync="is_loading"></loading>
    <div class="container">
      <div class="row">
        <div v-if="delights.length === 0">
          <div class="card delight-card border-0 col">
            <div class="row no-gutters">
              <div class="col">
                <div class="card-body">
                  <h5 class="card-title text-light font-weight-bolder">
                    Alegrías agotadas
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <ul class="list-group">
            <li class="list-group-item border-0" v-for="delight in delights">
              <div class="card delight-card border-0">
                <div class="row no-gutters">
                  <div class="col-sm-4">
                    <img
                      class="card-img delightImg"
                      :src="delight.small_picture | fullUrl"
                      widht="150"
                      height="150"
                      loading="lazy"
                    />
                  </div>
                  <div class="col-sm-8">
                    <div class="card-body">
                      <h5 class="card-title text-light font-weight-bolder">
                        {{ delight.name }}
                      </h5>
                      <small class="card-text text-light font-weight-bolder">{{
                        delight.description
                      }}</small
                      ><br />
                      <button
                        v-if="!is_added"
                        class="btn btn-default mt-2 border border-light text-light"
                        @click="addDelight(delight)"
                      >
                        Agregar alegr&iacute;a
                        {{ delight.prices[0].price | currency }}
                      </button>
                      <span v-else class="bg-secondary text-light px-2 py-1"
                        >Alegría agregada</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- .row -->
    </div>
  </div>
  <!-- .product-section -->
</template>

<script>
const axios = require("axios");

import Loading from "vue-loading-overlay";

export default {
  name: "DelightSelection",
  props: ["validate", "modify"],
  components: {
    Loading,
  },
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
      delights: [],
      is_added: false,
      is_loading: true,
    };
  },
  filters: {
    fullUrl: function (file) {
      return file;
    },
    currency: function (price) {
      return "$" + price;
    },
  },
  mounted() {
    if ($cookies.get("ctoken")) {
      axios({
        method: "GET",
        url: this.api_url + "/delights/available",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("ctoken"),
        },
      })
        .then((response) => {
          this.is_loading = false;
          if (response.data.status) {
            this.delights = response.data.data;
            console.info("Se obtuvieron las alegrias", this.delights);
            this.$emit("modify", true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      console.info("No se encontro la cookie");
    }
  },
  methods: {
    addDelight: function (delight) {
      // Se envia el evento hacia el productList.vue
      this.$emit("click", delight);
      this.is_added = true;
    },
  },
};
</script>

<style scoped>
.delightImg{
  aspect-ratio: 3/2;
}
</style>

